import React from 'react';

interface DealFeatureProps {
  feature: string;
  color: string;
}

const DealFeature: React.FC<DealFeatureProps> = ({ feature, color }) => {
  return (
    <div className="flex items-center space-x-3">
      <span 
        className="w-2 h-2 rounded-full"
        style={{ backgroundColor: color }}
      />
      <span className="text-gray-600">{feature}</span>
    </div>
  );
};

export default DealFeature;